import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonUi, PageHeaderUi } from "../../ui";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { ProveedorTable } from "./ProveedorTable";
import { proveedorClearActive, proveedoresStartLoad } from "../../../actions";
import { ProveedorScreen } from "./ProveedorScreen";

const ProveedorListScreen = ({ handleOpenForm }) => {
  const dispatch = useDispatch();
  const { proveedores, loading } = useSelector((state) => state.proveedor);
  const handleActualizar = () => dispatch(proveedoresStartLoad());
  return (
    <PageHeaderUi
      title="Proveedores"
      subTitle="Listado"
      extra={[
        <ButtonUi
          typeUi={TipoButtonConstants.Actualizar}
          onClick={handleActualizar}
          key="Actualizar"
        />,
        <ButtonUi
          typeUi={TipoButtonConstants.Nuevo}
          onClick={handleOpenForm}
          key="Nuevo"
        />,
      ]}
    >
      <ProveedorTable
        data={proveedores}
        loading={loading}
        handleOpenForm={handleOpenForm}
      />
    </PageHeaderUi>
  );
};

export const ProveedorList = () => {
  const dispatch = useDispatch();
  const [visibleForm, setVisibleForm] = useState(false);
  const handleOpenForm = () => setVisibleForm(true);
  const handleCloseForm = () => {
    setVisibleForm(false);
    dispatch(proveedorClearActive());
  };
  useEffect(() => {
    dispatch(proveedoresStartLoad());
  }, []);

  if (visibleForm) {
    return <ProveedorScreen handleCloseForm={handleCloseForm} />;
  } else {
    return <ProveedorListScreen handleOpenForm={handleOpenForm} />;
  }
};

export default ProveedorList;
